import _ from "underts";
import { formaters } from "vincent-utils";
import { HMObject } from "../../types/HMObject.js";
import { typeConsts } from "../../cadendar-consts.js";
export const isClosedRdvCase = (obj) => {
    return (typeof obj === "object" &&
        obj !== null &&
        "tag" in obj &&
        obj.tag === "closed");
};
export const isEmptyRdvCase = (obj) => {
    return (typeof obj === "object" &&
        obj !== null &&
        "tag" in obj &&
        obj.tag === "empty");
};
export const isRdvCase = (obj) => {
    return typeof obj === "object" && obj !== null && _.assertProp(obj, "_id");
};
const rdvRank = (rdv) => rdv.hour * 60 + rdv.minute;
//prend le tableau de toutes les cases du jour et remplace certaines cases vides par les vrais rdvs
const fillRdvs = (arrayOfEmptyRdvs, daysRdvs, débutHeureAffichage, duréeMinRdv) => {
    const sortedRdvs = _.sortBy(daysRdvs, rdvRank);
    const emptyRdvsCopy = [...arrayOfEmptyRdvs];
    let casesAdded = 0;
    sortedRdvs.forEach((rdv) => {
        const tempsDepuisStart = rdv.hour * 60 + rdv.minute - débutHeureAffichage;
        const numeroCase = tempsDepuisStart / duréeMinRdv - casesAdded;
        const nbrCases = rdv.duration / duréeMinRdv; //nombre de cases à ajouter
        casesAdded += nbrCases - 1;
        emptyRdvsCopy.splice(numeroCase, nbrCases, { ...rdv, tag: "rdv" });
    });
    return emptyRdvsCopy;
};
const createRdvsArrayBlock = function (minutesdebut, minutesfin, duréeMinRdv, stumpObject) {
    "use strict";
    const resultArray = [];
    for (let m = minutesdebut; m < minutesfin; m += duréeMinRdv) {
        const hmObject = new HMObject(m);
        resultArray.push({
            ...stumpObject,
            hour: hmObject.heure,
            minute: hmObject.minute,
        });
    }
    return resultArray;
};
const generateEmptyBlocks = (plagesDuJour, duréeMinRdv, débutHeureAffichage, finHeureAffichage, date) => {
    if (plagesDuJour.length === 0) {
        return [];
    }
    const resultArray = [];
    const emptyRdvStump = {
        patient: null,
        duration: duréeMinRdv,
        tag: "empty",
    };
    const closedRdvStump = {
        patient: null,
        duration: duréeMinRdv,
        tag: "closed",
    };
    resultArray.push(createRdvsArrayBlock(débutHeureAffichage, formaters.getHourAsMinutesFromHMObject(plagesDuJour[0].start), duréeMinRdv, closedRdvStump));
    const length = plagesDuJour.length;
    for (let i = 0; i < length; i++) {
        resultArray.push(createRdvsArrayBlock(formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].start), formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].end), duréeMinRdv, emptyRdvStump));
        if (i < length - 1) {
            resultArray.push(createRdvsArrayBlock(formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].end), formaters.getHourAsMinutesFromHMObject(plagesDuJour[i + 1].start), duréeMinRdv, closedRdvStump));
        }
    }
    resultArray.push(createRdvsArrayBlock(formaters.getHourAsMinutesFromHMObject(plagesDuJour[length - 1].end), finHeureAffichage, duréeMinRdv, closedRdvStump));
    return _.compact(resultArray.flat(2)).map((c) => ({ ...c, date }));
};
const removeCancelledRdvsFromDayArray = function (dayCasesArray, duréeMinRdv) {
    "use strict";
    const arr = dayCasesArray.map(function (rdvCase) {
        if (rdvIsCancelled(rdvCase)) {
            return replaceRdvWithEmptyCases(rdvCase, duréeMinRdv);
        }
        return rdvCase;
    });
    return arr.flat();
};
const rdvIsCancelled = function (rdv) {
    return rdv.type === typeConsts.ANN || rdv.type === typeConsts.ANNTARD;
};
const replaceRdvWithEmptyCases = function (rdv, duréeMinRdv) {
    const heure = rdv.hour, minute = rdv.minute, duree = rdv.duration, nombre = duree / duréeMinRdv, date = rdv.date, resultArr = [];
    if (nombre === Math.floor(nombre)) {
        for (let i = 0; i < nombre; i++) {
            const obj1 = new HMObject({ heure: heure, minute: minute });
            obj1.add(i * duréeMinRdv);
            const obj = {
                heure: obj1.heure,
                minute: obj1.minute,
                date,
                tag: "empty",
                patient: null,
                duree: duréeMinRdv,
            };
            resultArr.push(obj);
        }
        return resultArr;
    }
};
function consolidateClosedCases(cases, duréeMinRdv) {
    if (!_.isNonEmpty(cases)) {
        return [];
    }
    const firstCase = _.head(cases);
    const lastCase = _.lastNonEmpty(cases);
    const obj1 = new HMObject({
        heure: firstCase.hour,
        minute: firstCase.minute,
    });
    const obj2 = new HMObject({
        heure: lastCase.hour,
        minute: lastCase.minute,
    });
    const obj = {
        hour: obj1.heure,
        minute: obj1.minute,
        date: firstCase.date,
        tag: "closedByHoraire",
        type: typeConsts.CLOSEDBYHORAIRES,
        objet: "",
        duration: (obj2.heure - obj1.heure) * 60 + obj2.minute - obj1.minute + duréeMinRdv,
    };
    return [obj];
}
function isClosedCase(obj) {
    return obj.tag === "closed";
}
const replaceClosedCasesBetweenPlageWithUniqueClosedCase = function (dayCasesArray, plagesDuJour, duréeMinRdv) {
    "use strict";
    const resultArray = [];
    if (!_.isNonEmpty(plagesDuJour)) {
        return dayCasesArray;
    }
    const length = plagesDuJour.length;
    const beforeFirstPlage = dayCasesArray
        .filter(function (rdvCase) {
        return (rdvCase.hour * 60 + rdvCase.minute <
            formaters.getHourAsMinutesFromHMObject(_.head(plagesDuJour).start));
    })
        .filter(isClosedCase);
    const beforeFirstPlageConsolidated = consolidateClosedCases(beforeFirstPlage, duréeMinRdv);
    resultArray.push(...beforeFirstPlageConsolidated);
    const afterFirstPlage = dayCasesArray
        .filter(function (rdvCase) {
        return (rdvCase.hour * 60 + rdvCase.minute >=
            formaters.getHourAsMinutesFromHMObject(plagesDuJour[length - 1].end));
    })
        .filter(isClosedCase);
    const afterFirstPlageConsolidated = consolidateClosedCases(afterFirstPlage, duréeMinRdv);
    for (let i = 0; i < length; i++) {
        if (i + 1 == length) {
            const startPlage = formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].start);
            const endPlage = formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].end);
            const casesInPlage = dayCasesArray.filter(function (rdvCase) {
                return (rdvCase.hour * 60 + rdvCase.minute >= startPlage &&
                    rdvCase.hour * 60 + rdvCase.minute < endPlage);
            });
            resultArray.push(...casesInPlage);
            break;
        }
        const startPlage = formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].start);
        const startBetween = formaters.getHourAsMinutesFromHMObject(plagesDuJour[i].end);
        const endBetween = formaters.getHourAsMinutesFromHMObject(plagesDuJour[i + 1].start);
        const casesInFirstPlage = dayCasesArray.filter(function (rdvCase) {
            return (rdvCase.hour * 60 + rdvCase.minute >= startPlage &&
                rdvCase.hour * 60 + rdvCase.minute < startBetween);
        });
        resultArray.push(...casesInFirstPlage);
        const casesBetweenPlages = dayCasesArray
            .filter(function (rdvCase) {
            const heure = rdvCase.hour, minute = rdvCase.minute;
            return (heure * 60 + minute >= startBetween &&
                heure * 60 + minute < endBetween);
        })
            .filter(isClosedCase);
        if (casesBetweenPlages.length > 0) {
            const objs = consolidateClosedCases(casesBetweenPlages, duréeMinRdv);
            resultArray.push(...objs);
        }
    }
    resultArray.push(...afterFirstPlageConsolidated);
    return resultArray;
};
const getRdvsWithEmpties = (plagesDuJour, daysRdvs, duréeMinRdv, débutHeureAffichage, finHeureAffichage, date) => {
    const emptyBlocs = generateEmptyBlocks(plagesDuJour, duréeMinRdv, débutHeureAffichage, finHeureAffichage, date);
    const dayWithRdvs = fillRdvs(emptyBlocs, daysRdvs, débutHeureAffichage, duréeMinRdv);
    const dayWithClosedCasesConsolidated = replaceClosedCasesBetweenPlageWithUniqueClosedCase(dayWithRdvs, plagesDuJour, duréeMinRdv);
    return dayWithClosedCasesConsolidated;
};
export { fillRdvs, generateEmptyBlocks, replaceRdvWithEmptyCases, removeCancelledRdvsFromDayArray, getRdvsWithEmpties, };
//# sourceMappingURL=agendaDayBuilder.js.map